import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaforpunetoaurangabad() {



    const cardData =
    {
        keyword: 'Urbania for Pune to Aurangabad on Rent',
        heading: 'Urbania on rent in pune: Urbania for Pune to Aurangabad on Rent',
        headingDescription: 'Urbania On Rent in Pune provides reliable and comfortable Urbania for Pune to Aurangabad on Rent services for families, corporate groups, tourists, and event travelers planning trips to Aurangabad. Our well-maintained Force Urbania fleet offers spacious seating, air-conditioned comfort, and smooth performance, making it ideal for long-distance travel, weekend getaways, corporate tours, and group sightseeing from Pune to Aurangabad. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free journey. Supported by 24/7 booking assistance, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for Urbania hire from Pune to Aurangabad.',

        top: 'Top Places to Visit in Aurangabad with Urbania on rent in pune',


    "topPlaces": [
  {
    "title": "Ajanta Caves",
    "description": "The Ajanta Caves, a UNESCO World Heritage Site, are a series of 30 rock-cut Buddhist cave monuments dating from the 2nd century BCE to about 480 CE. The caves feature intricate frescoes, sculptures, and paintings depicting the life of Buddha and various Jataka tales. Surrounded by lush hills and a river valley, the site is a blend of spiritual significance, historical importance, and artistic brilliance."
  },
  {
    "title": "Ellora Caves",
    "description": "Ellora Caves, another UNESCO World Heritage Site, consist of 34 monasteries and temples carved into rock, representing Buddhist, Hindu, and Jain traditions. The most notable is the Kailasa Temple, a massive monolithic structure dedicated to Lord Shiva. Visitors can explore the intricate carvings, sculptures, and the architectural marvels showcasing India’s rich cultural heritage."
  },
  {
    "title": "Bibi Ka Maqbara",
    "description": "Bibi Ka Maqbara, often called the 'Mini Taj Mahal,' is a mausoleum built by Azam Shah in memory of his mother Dilras Banu Begum. The white marble structure, surrounded by gardens and fountains, is a fine example of Mughal architecture and attracts photographers and history enthusiasts for its aesthetic appeal and historical significance."
  },
  {
    "title": "Daulatabad Fort",
    "description": "Daulatabad Fort, also known as Devagiri Fort, is a 12th-century fortress famous for its strategic design, steep incline, and hidden passageways. Visitors can trek to the fort to explore its massive ramparts, intricate defense mechanisms, and panoramic views of the surrounding landscape. It is an important historical and architectural landmark near Aurangabad."
  },
  {
    "title": "Aurangabad Caves",
    "description": "Aurangabad Caves are a set of 12 rock-cut Buddhist shrines located on a hill, known for their intricate sculptures and reliefs. Dating back to the 6th–7th centuries, the caves depict Buddhist mythology and offer a serene environment for history lovers and travelers seeking cultural exploration."
  },
  {
    "title": "Panchakki",
    "description": "Panchakki is a 17th-century water mill complex built for grinding grain for a nearby monastery. The site features beautiful gardens, a water channel system, and historic architecture. Visitors can enjoy the peaceful ambiance, learn about historical engineering methods, and explore the cultural heritage of Aurangabad."
  },
  {
    "title": "Salim Ali Lake and Bird Sanctuary",
    "description": "Salim Ali Lake, surrounded by a bird sanctuary, is a haven for migratory and local birds. Nature lovers and bird watchers can enjoy serene walks, photography, and observing rare species in their natural habitat. The area provides a refreshing escape from the city and a tranquil spot for relaxation."
  },
  {
    "title": "Ghrishneshwar Temple",
    "description": "Ghrishneshwar Temple is one of the twelve Jyotirlinga shrines dedicated to Lord Shiva, located near Ellora. The temple features beautiful Maratha-style architecture and attracts devotees and tourists seeking spiritual experiences, cultural immersion, and historical significance."
  },
  {
    "title": "Aurangabad Gateways (Bhadkal Gate, Delhi Gate)",
    "description": "Aurangabad is known for its historic gateways like Bhadkal Gate and Delhi Gate, remnants of medieval city architecture. Visitors can explore these beautifully carved stone structures, learn about the city’s history, and enjoy the nearby markets for a complete cultural experience."
  },
  {
    "title": "Grishneshwar Jyotirlinga Temple",
    "description": "Another significant Jyotirlinga temple near Ellora, Grishneshwar is revered for its spiritual importance and intricate carvings. Pilgrims visit to offer prayers, participate in rituals, and admire the temple’s architecture, making it a prominent religious and tourist destination in Aurangabad."
  }
],



"services": [
    {
      "name": "Pune to Aurangabad Urbania on Rent",
      "description": "Pune to Aurangabad Urbania on Rent provides comfortable and reliable vehicles for long-distance travel between Pune and Aurangabad. Perfect for families, groups, and corporate travelers, this service ensures spacious seating, professional chauffeurs, ample luggage space, and a smooth, safe, and stress-free journey while enjoying a scenic and comfortable ride."
    },
    {
      "name": "Urbania Hire Pune to Aurangabad",
      "description": "Urbania Hire Pune to Aurangabad offers convenient and dependable intercity vehicle rental options. Ideal for group travel, corporate trips, and family outings, the service emphasizes timely pickups, trained chauffeurs, well-maintained vehicles, and a comfortable journey to Aurangabad without any delays or hassles."
    },
    {
      "name": "Urbania Bus Rental Pune to Aurangabad",
      "description": "Urbania Bus Rental Pune to Aurangabad provides spacious buses suitable for large groups, corporate tours, and family trips. Equipped with ample seating, safety features, and professional chauffeurs, these buses ensure an organized, comfortable, and enjoyable long-distance journey from Pune to Aurangabad."
    },
    {
      "name": "Urbania AC Bus Pune to Aurangabad",
      "description": "Urbania AC Bus Pune to Aurangabad offers fully air-conditioned buses for maximum comfort during long-distance travel. Ideal for families, corporate teams, and tourists, these buses come with climate control, spacious seating, luggage space, and experienced drivers for a smooth and relaxing journey from Pune to Aurangabad."
    },
    {
      "name": "Pune Aurangabad Urbania One Way Hire",
      "description": "Pune Aurangabad Urbania One Way Hire provides flexible options for individuals, families, and corporate groups. Vehicles are well-maintained, spacious, and driven by professional chauffeurs, offering a convenient, safe, and hassle-free journey from Pune to Aurangabad without worrying about return trips."
    },
    {
      "name": "Pune Aurangabad Urbania Round Trip Hire",
      "description": "Pune Aurangabad Urbania Round Trip Hire delivers reliable and comfortable round-trip transportation solutions. With clean vehicles, professional drivers, and punctual service, travelers can enjoy a seamless journey to Aurangabad and back to Pune, making it perfect for family outings, corporate trips, and group tours."
    },
    {
      "name": "Corporate Urbania Pune to Aurangabad",
      "description": "Corporate Urbania Pune to Aurangabad provides professional transportation for business trips, corporate events, and conferences. Vehicles offer executive comfort, spacious seating, and trained chauffeurs, ensuring a smooth, productive, and reliable travel experience for corporate teams traveling between Pune and Aurangabad."
    },
    {
      "name": "Family Tour Urbania Pune to Aurangabad",
      "description": "Family Tour Urbania Pune to Aurangabad ensures safe, comfortable, and spacious travel for family vacations and group outings. With courteous chauffeurs, ample luggage space, and well-maintained interiors, families can focus on sightseeing, historical tours, and leisure without worrying about travel logistics."
    },
    {
      "name": "Luxury Urbania Pune to Aurangabad",
      "description": "Luxury Urbania Pune to Aurangabad provides high-end air-conditioned vehicles with plush interiors and superior ride quality for VIPs, executives, and travelers seeking premium comfort. Professional chauffeurs, smooth rides, and attention to detail guarantee a luxurious long-distance journey from Pune to Aurangabad."
    },
    {
      "name": "Affordable Urbania Pune to Aurangabad",
      "description": "Affordable Urbania Pune to Aurangabad delivers cost-effective intercity transportation without compromising on comfort or reliability. Ideal for families, groups, and budget-conscious travelers, the service offers safe, clean vehicles and professional chauffeurs for a dependable journey from Pune to Aurangabad."
    },
    {
      "name": "Chauffeur Driven Urbania Pune to Aurangabad",
      "description": "Chauffeur Driven Urbania Pune to Aurangabad provides stress-free travel with verified and experienced drivers. Vehicles are spacious, well-maintained, and suitable for long-distance trips, allowing travelers to enjoy a safe, convenient, and comfortable ride from Pune to Aurangabad without worrying about driving or navigation."
    },
    {
      "name": "Pune Aurangabad Urbania Travel Service",
      "description": "Pune Aurangabad Urbania Travel Service offers end-to-end transportation solutions for leisure, corporate, and group travel. With reliable vehicles, experienced chauffeurs, punctual service, and luggage assistance, this service ensures a smooth, comfortable, and enjoyable journey from Pune to Aurangabad for all types of travelers."
    },
    {
      "name": "Best Urbania Hire Pune to Aurangabad",
      "description": "Best Urbania Hire Pune to Aurangabad delivers top-rated intercity travel services with a focus on comfort, reliability, and customer satisfaction. Suitable for families, corporate teams, and group travelers, it ensures a smooth, safe, and timely journey, making it the preferred choice for Pune to Aurangabad travel."
    },
    {
      "name": "Pune to Aurangabad Urbania Booking",
      "description": "Pune to Aurangabad Urbania Booking allows convenient reservation of Urbania vehicles for one-way or round-trip journeys. Travelers can select from multiple vehicle types to ensure a comfortable, safe, and hassle-free trip from Pune to Aurangabad with professional chauffeur services included."
    },
    {
      "name": "Urbania for Outstation Trip Pune to Aurangabad",
      "description": "Urbania for Outstation Trip Pune to Aurangabad provides reliable long-distance travel solutions with well-maintained vehicles and professional chauffeurs. Perfect for family trips, corporate travel, and group outings, the service emphasizes safety, comfort, punctuality, and a stress-free journey from Pune to Aurangabad."
    }
  ],
  "tableData": [
    ["Pune to Aurangabad Urbania on Rent", "Urbania Hire Pune to Aurangabad"],
    ["Urbania Bus Rental Pune to Aurangabad", "Urbania AC Bus Pune to Aurangabad"],
    ["Pune Aurangabad Urbania One Way Hire", "Pune Aurangabad Urbania Round Trip Hire"],
    ["Corporate Urbania Pune to Aurangabad", "Family Tour Urbania Pune to Aurangabad"],
    ["Luxury Urbania Pune to Aurangabad", "Affordable Urbania Pune to Aurangabad"],
    ["Chauffeur Driven Urbania Pune to Aurangabad", "Pune Aurangabad Urbania Travel Service"],
    ["Best Urbania Hire Pune to Aurangabad", "Pune to Aurangabad Urbania Booking"],
    ["Urbania for Outstation Trip Pune to Aurangabad", ""]
  ],





"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania for Pune to Aurangabad On Rent",
        "WhyChoosedescription": "Urbania for Pune to Aurangabad On Rent is perfect for comfortable and spacious group travel, ideal for family trips, corporate travel, weddings, and outstation journeys."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania for Pune to Aurangabad On Rent provides well-maintained Force Urbania vehicles with ample seating and luggage space, ensuring a smooth and hassle-free journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Urbania for Pune to Aurangabad On Rent comes with skilled drivers familiar with Pune-Aurangabad routes and highways, ensuring safe, timely, and stress-free travel."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Choose Urbania for Pune to Aurangabad On Rent for competitive rates with no hidden charges, making outstation group travel budget-friendly and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania for Pune to Aurangabad On Rent provides round-the-clock assistance for bookings, inquiries, and last-minute travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Urbania for Pune to Aurangabad On Rent is available for one-way trips, round trips, corporate travel, wedding transportation, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania vehicles for Pune to Aurangabad trips are regularly cleaned, sanitized, and serviced to ensure a safe and comfortable journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania for Pune to Aurangabad On Rent guarantees timely pickups and dependable service, ensuring stress-free and smooth travel."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania for Pune to Aurangabad On Rent available for local travel as well?',
        answer: 'Yes, Urbania for Pune to Aurangabad On Rent can also be booked for local travel within Pune or nearby areas, offering a comfortable and spacious ride.',
    },
    {
        question: 'How can I book Urbania for Pune to Aurangabad On Rent?',
        answer: 'You can book Urbania for Pune to Aurangabad On Rent via phone, WhatsApp, or online for quick and hassle-free reservations.',
    },
    {
        question: 'Why choose Urbania for Pune to Aurangabad On Rent for group travel?',
        answer: 'Urbania for Pune to Aurangabad On Rent provides ample seating, luggage space, and a smooth ride, making it ideal for family, corporate, and group travel.',
    },
    {
        question: 'Is Urbania for Pune to Aurangabad On Rent suitable for corporate and event travel?',
        answer: 'Yes, it is perfect for corporate trips, airport transfers, weddings, events, and one-way or round-trip travel to Aurangabad.',
    },
    {
        question: 'Are drivers experienced with Urbania for Pune to Aurangabad On Rent?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling Force Urbania vehicles to ensure safe and comfortable travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations with Urbania for Pune to Aurangabad On Rent?',
        answer: 'Absolutely. Urbania for Pune to Aurangabad On Rent allows flexible pickup and drop-off across Pune and Aurangabad.',
    },
    {
        question: 'Is Urbania for Pune to Aurangabad On Rent available 24x7?',
        answer: 'Yes, Urbania for Pune to Aurangabad On Rent operates 24x7 to accommodate travel needs at any time.',
    },
    {
        question: 'Are hygiene and safety standards maintained for Urbania for Pune to Aurangabad On Rent?',
        answer: 'Yes, all vehicles are regularly cleaned, sanitized, and maintained with strict safety protocols for every trip.',
    },
    {
        question: 'What payment options are available for Urbania for Pune to Aurangabad On Rent?',
        answer: 'Urbania for Pune to Aurangabad On Rent accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey to ensure a smooth and stress-free experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Vikram Shinde',
        feedback: 'We booked Urbania for Pune to Aurangabad On Rent for a family trip. The vehicle was spacious, comfortable, and reliable. Excellent service!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Pooja Patil',
        feedback: 'Urbania for Pune to Aurangabad On Rent provided smooth service for our corporate travel. The driver was professional and punctual. Highly recommended!',
        rating: 5,
    },
];






























































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania for Pune to Aurangabad on Rent",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-pune-to-aurangabad.jpg",
  "description": "Urbania for Pune to Aurangabad on Rent offers AC and non-AC Urbania bus rental services for one-way and round-trip travel. Perfect for family tours, corporate trips, luxury travel, and outstation trips. Chauffeur-driven Urbania buses ensure comfortable, safe, and affordable journeys from Pune to Aurangabad.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-pune-to-aurangabad-on-rent"
  }
};







    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania for Pune to Aurangabad on Rent | AC & Luxury Urbania Bus Rental 
  </title>

  <meta
    name="description"
    content="Book Urbania for Pune to Aurangabad on Rent for one-way or round-trip travel. AC and non-AC Urbania buses for family tours, corporate trips, luxury travel, and outstation trips. Chauffeur-driven service ensures safe and comfortable journeys."
  />

  <meta
    name="keywords"
    content="Pune to Aurangabad Urbania on Rent, Urbania Hire Pune to Aurangabad, Urbania Bus Rental Pune to Aurangabad, Urbania AC Bus Pune to Aurangabad, Pune Aurangabad Urbania One Way Hire, Pune Aurangabad Urbania Round Trip Hire, Corporate Urbania Pune to Aurangabad, Family Tour Urbania Pune to Aurangabad, Luxury Urbania Pune to Aurangabad, Affordable Urbania Pune to Aurangabad, Chauffeur Driven Urbania Pune to Aurangabad, Pune Aurangabad Urbania Travel Service, Best Urbania Hire Pune to Aurangabad, Pune to Aurangabad Urbania Booking, Urbania for Outstation Trip Pune to Aurangabad"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/36.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaforpunetoaurangabad;